import { queryParamHas } from './getQueryParam'
import Logger from './Logger'

export async function handleGdprTest(webModel: IWebViewModel): Promise<void> {
  if (queryParamHas('test', 'gdpr')) {
    // Load the vendorList and customPurposes from API, and attach them to the model.
    try {
      const launcherUrl = webModel.launcherUrl
      const customPurposeListLocation = `${launcherUrl}/cmp/${
        webModel.slug
      }/purposes.json`
      const globalVendorListLocation = `${launcherUrl}/cmp/vendorlist.json`

      const purposesProm = fetch(customPurposeListLocation)
      const vendorProm = fetch(globalVendorListLocation)
      const [purposesResponse, vendorResponse] = await Promise.all([
        purposesProm,
        vendorProm
      ])

      webModel.vendorList = await vendorResponse.json()
      webModel.customPurposes = await purposesResponse.json()
    } catch (err) {
      Logger.debug('GDPR Test Error: ', err)
    }
  }
}
